import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { DataCard } from '@/components/card'
import { FilterableTable } from '@/components/table/base'
import { STORE_STATUS } from '@/constants/store'
import { ROUTE_PARAM, ROUTE_URL } from '@/router/constants'
import { useGolfPricingStore } from '@/stores/golfPricing'
import {
  getGolfPricingTableFilters,
  getGolfPricingTableRows,
  GOLF_PRICING_TABLE_COLUMNS
} from '@/views/GolfPricing/golfPricing.dde.table'

export const DDE_GOLF_PRICING_TABLE_ID = 'dde-golf-pricing-table'

export const GolfPricingView = () => {
  const navigate = useNavigate()
  const { data, isFetching, isLoading, fetchData, resetState } = useGolfPricingStore(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching,
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    fetchData()
    return () => {
      resetState()
    }
  }, [])

  const tableRows = useMemo(() => getGolfPricingTableRows(data), [data])

  return (
    <DataCard title="Tournaments">
      <FilterableTable
        tableId={DDE_GOLF_PRICING_TABLE_ID}
        columns={GOLF_PRICING_TABLE_COLUMNS}
        filters={getGolfPricingTableFilters()}
        data={tableRows}
        loading={isLoading}
        disableColumnVisibility
        fetching={isFetching}
        clientSideFilters
        defaultSort={{
          attribute: 'startDateTime',
          order: 'desc'
        }}
        onRowClick={(row) =>
          navigate(
            ROUTE_URL.GOLF_PRICING.TOURNAMENT_LEADERBOARD.DEFAULT.replace(
              `:${ROUTE_PARAM.TOURNAMENT_ID}`,
              String(row.id)
            )
          )
        }
        clientSideSortAndPagination
      />
    </DataCard>
  )
}
